export default {"src":"/_next/static/media/agreena-logo.84e7c76e.svg","height":32,"width":132,"blurWidth":0,"blurHeight":0};